<template>
  <div
    :class="
      $twMerge(
        'text-white min-w-[160px] sm:min-w-[150px] xl:min-w-[210px] max-w-[210px] mb-6 md:mb-8',
        appendClass
      )
    "
  >
    <p
      v-if="title"
      :class="
        $twMerge(
          'font-semibold text-[#c588ff] text-lg md:text-2xl mb-1 text-center',
          titleClass
        )
      "
    >
      {{ title }}
    </p>
    <div class="relative">
      <ul
        class="relative after:content-[''] after:w-10 after:h-full after:absolute after:rotate-[28deg] after:bg-[linear-gradient(180.37deg,_#737CD3_29.35%,_#1B0742_131.96%)] after:right-10 after:-top-10 after:rounded-full after:blur-[50px] rounded-xl border border-[#4E519A] overflow-hidden bg-[linear-gradient(140.57deg,_#0B0130_10.98%,_#050018_93.74%)] shadow-[5px_5px_39.7px_3px_#00000040]"
      >
        <li
          v-for="technology in technologies"
          :key="technology.text"
          class="z-10 relative hover:bg-[linear-gradient(240.57deg,_#351980_10.98%,_#31115a_93.74%)] transition-colors duration-300 ease-in-out"
        >
          <NuxtLink
            v-if="technology.link"
            :to="technology.link"
            @click="handleOpenModal(technology.link)"
            class="flex items-center gap-3 lg:gap-4 p-3"
          >
            <slot name="icon">
              <span class="min-w-7 lg:min-w-9">
                <NuxtImg
                  alt="techImg"
                  v-if="technology.img"
                  :src="technology.img"
                  :width="technology.imgWidth"
                  loading="lazy"
                  :height="technology.imgHeight"
                  format="webp"
                />
              </span>
            </slot>
            <slot name="text">
              <span class="text-white font-medium tracking-[1.5px]">{{
                technology.text
              }}</span>
            </slot>
          </NuxtLink>
          <div
            class="h-px w-full bg-[image:var(--border-bottom-pile)] shadow-[0px_2px_0px_0px_#00000040]"
          ></div>
        </li>
      </ul>
      <p
        v-if="leftTitle"
        class="text-[#cdb3d5] font-medium tracking-[1px] uppercase absolute max-sm:hidden left-[-25px] top-1/2 -translate-y-1/2 rotate-180"
        style="writing-mode: vertical-rl"
      >
        {{ leftTitle }}
      </p>
    </div>
  </div>
  <Teleport to="body">
    <WrComingSoonPopup
      v-if="isVisible"
      :is-open="isVisible"
      @close="isVisible = false"
    />
  </Teleport>
</template>

<script setup lang="ts">
const { $twMerge } = useNuxtApp();
const LazyWrComingSoonPopup = defineAsyncComponent(
  () => import("~/components/molecules/WrComingSoonPopup.vue")
);
type Technology = {
  icon?: string;
  img?: string;
  iconSize?: string;
  imgWidth?: string;
  imgHeight?: string;
  text: string;
  link?: string | any;
};

type Props = {
  title?: string;
  leftTitle?: string;
  technologies?: Technology[];
  appendClass?: string;
  titleClass?: string;
};
const isVisible = ref(false);

const handleOpenModal = (link: string) => {
  if (link == "/") {
    isVisible.value = true;
  }
};

const props = withDefaults(defineProps<Props>(), {
  technologies: () => [
    { icon: "carbon:machine-learning", text: "Machine", link: "/" },
    { icon: "carbon:text-align-center", text: "Text", link: "/" },
    { icon: "carbon:document-audio", text: "Speech-to-Text", link: "/" },
    { icon: "carbon:video-add", text: "Computer Vision", link: "/" },
    {
      icon: "material-symbols-light:view-in-ar-outline-rounded",
      text: "Assisted Video",
      link: "/",
    },
  ],
});
</script>
